import React from 'react';
import PropTypes from 'prop-types';
import css from './YfDataStatus.css';
import Tooltip from '../../../components/molecules/Tooltip';
import {
    formatDelta,
    formatExactValue,
    hasDeltaChip,
    metricDisplayValue,
    yfTranslationKey,
} from '../../yfDataStatusUtils';
import { auditDeltaShape } from './propTypes';

function MetricCell({ delta, comparable, translate }) {
    const { label, tone } = formatDelta(delta);
    const tooltip = [
        `${translate(yfTranslationKey('SINGULAR_VALUE_TOOLTIP'))}: ${_exact(delta.singular_value, translate)}`,
        `${translate(yfTranslationKey('ADNET_VALUE_TOOLTIP'))}: ${_exact(delta.adnet_value, translate)}`,
    ].join('\n');

    const chipTooltip = translate(yfTranslationKey('DELTA_CHIP_TOOLTIP'), {
        singular: _exact(delta.singular_value, translate),
        adnet: _exact(delta.adnet_value, translate),
    });

    return (
        <div className={css.metricCell} title={tooltip}>
            <div className={css.metricValue}>{metricDisplayValue(delta)}</div>
            {comparable && hasDeltaChip(delta) && (
                <Tooltip title={chipTooltip} wrapperClass={css.chipTooltip}>
                    <span className={`${css.chip} ${css[`chip_${tone}`]}`}>{label}</span>
                </Tooltip>
            )}
        </div>
    );
}

function _exact(value, translate) {
    return value === null || value === undefined
        ? translate(yfTranslationKey('NO_DATA_TOOLTIP_VALUE'))
        : formatExactValue(value);
}

MetricCell.propTypes = {
    delta: auditDeltaShape.isRequired,
    comparable: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

export default MetricCell;
